export const FooterLogo = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 139">
        <g id="Group">
          <path
            id="Vector"
            d="M6 6.08398V10.546V10.636V10.546C6 11.8201 6.55588 12.9481 7.41776 13.6781C7.83918 14.0351 8.11765 14.5171 8.11765 15.0521V22.5002C8.11765 23.3282 8.82918 24.0002 9.70588 24.0002C10.5826 24.0002 11.2941 23.3282 11.2941 22.5002V15.0521C11.2941 14.5171 11.5726 14.0351 11.994 13.6781C12.8559 12.9481 13.4118 11.8201 13.4118 10.546V6.08398V10.546"
            stroke="#8BAA36"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M9.70508 11.0001V6"
            stroke="#8BAA36"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M23.9992 7.05153C23.9992 6.49952 23.5248 6.05151 22.9404 6.05151H21.8815C20.1271 6.05151 18.7051 7.39453 18.7051 9.05155V15.0516C18.7051 16.3556 19.5913 17.4546 20.8227 17.8677V22.4997C20.8227 23.3277 21.5343 23.9997 22.411 23.9997C23.2877 23.9997 23.9992 23.3277 23.9992 22.4997V18.0517V7.05153Z"
            stroke="#8BAA36"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};
export const FooterEmailLogo = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 18 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 204">
        <path
          id="Path 13"
          d="M2.6 1H15.4C15.824 1.00119 16.2302 1.1596 16.53 1.44065C16.8298 1.7217 16.9987 2.10254 17 2.5V11.5C16.9987 11.8975 16.8298 12.2783 16.53 12.5593C16.2302 12.8404 15.824 12.9988 15.4 13H2.6C2.17604 12.9988 1.76981 12.8404 1.47003 12.5593C1.17024 12.2783 1.00127 11.8975 1 11.5V2.5C1.00127 2.10254 1.17024 1.7217 1.47003 1.44065C1.76981 1.1596 2.17604 1.00119 2.6 1V1Z"
          stroke="#FAFAFA"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Path 14"
          d="M17 2.49951L9 7.74951L1 2.49951"
          stroke="#FAFAFA"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
